import React from "react";
import { Link } from "react-router-dom";
import "./Headbar.css";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { deleteItem } from "../../Redux/Actions";
import ItemsNum from "../ItemsNum/ItemsNum";
import { decreasNotification } from "../../Redux/Actions";
import Login from "../Login/Login";


function Headbar() {
  const [click, setClick] = useState(false);
  const cartData = useSelector((state) => state.addCart);
  const [readCart, setReadCart] = useState(cartData);
  const dispatch = useDispatch();

  const notificationOfCart = useSelector((state) => state.notification);

  useEffect(() => {
    setReadCart(cartData);
    console.log(readCart);
  }, [cartData]);

  const deletItem = (id) => {
    clearNotification();
    dispatch(deleteItem(id));
  };
  const handleClick = () => {
    setClick(!click);
  };
  

  const clearNotification = () => {
    dispatch(decreasNotification());
  };

  return (
    <div className="headbar">
      <div className="container">
        <div className="part1">
          <h6>English |</h6>

          <Login />
        </div>
        <div className="part2">
          <Link className="navbar-brand" to="/">
            ONLINE SHOP
          </Link>
        </div>
        <div className="part3">
          <div className="catr-notification" onClick={handleClick}>
            <i className="far fa-shopping-cart"></i>
            <p>{notificationOfCart}</p>
          </div>
          <div className=" cart ">
            {click && (
              <div className=" shop-cart">
                <div className="shop-icon container ">
                  <i className="fal fa-bags-shopping"></i>
                  <h4>SHOPPING CART</h4>
                </div>

                {readCart.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="container add-cart">
                        <div className="cart-img">
                          <img
                            src={"https://" + item.media.images[0].url}
                            alt=""
                          />
                        </div>
                        <div className=" container data-content">
                          <p>{item.name}</p>
                        </div>
                      </div>
                      <div className=" container price-cart">
                        <p>{item.price.current.text}</p>
                        <ItemsNum />
                        <i
                          class="fas fa-minus-circle"
                          onClick={() => deletItem(item.id)}
                        ></i>
                      </div>
                      <hr />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Headbar;
